module.exports = __webpack_public_path__ + "static/media/promo_mobile_sfw.b64a5c65.webp";